(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const NAME = 'gift-card-recipient-form';

    if (customElements.get(NAME)) return;

    class GiftCardRecipientForm extends HTMLElement {
      #abort = null;
      #toggle = null;
      #fields = null;
      #controls = [];
      #email = null;

      connectedCallback() {
        this.#toggle = this.querySelector('[data-recipient-toggle]');
        this.#fields = this.querySelector('[data-recipient-fields]');
        if (!this.#toggle || !this.#fields) return;

        this.#controls = [...this.#fields.querySelectorAll('input, textarea')];
        this.#email = this.#fields.querySelector('input[type="email"]');

        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.#toggle.addEventListener('change', () => this.#sync(), {
          signal,
        });

        // A back or forward visit that misses the bfcache restores the ticked
        // box after this element has synced, and fires no change event, so the
        // fields would open while still disabled. Restoring is done by
        // `pageshow`, so sync again then.
        window.addEventListener('pageshow', () => this.#sync(), { signal });

        // The drawer names the form an add came from. After one succeeds the
        // next card starts unticked and empty, so a second gift cannot go to
        // the first recipient by accident. Not gated on the box: it may have
        // been unticked while the add was in flight, which would otherwise
        // leave the first recipient waiting in the folded fields.
        document.addEventListener(
          'cart:updated',
          (event) => {
            if (event.detail?.formId !== this.dataset.formId) return;

            this.#toggle.checked = false;
            for (const control of this.#controls) control.value = '';
            this.#sync();
          },
          { signal },
        );

        this.#sync();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
      }

      /**
       * Folded fields are disabled, so they leave the submission and the tab
       * order together. Their values are kept, so unticking by mistake and
       * ticking again loses nothing — a disabled control is never sent.
       */
      #sync() {
        const open = this.#toggle.checked;

        this.#fields.inert = !open;

        for (const control of this.#controls) {
          control.disabled = !open;
        }

        if (this.#email) this.#email.required = open;
      }
    }

    customElements.define(NAME, GiftCardRecipientForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const NAME = 'product-dynamic-badges';

    class ProductDynamicBadges extends HTMLElement {
      #boundVariantChange = null;
      #variants = [];
      #lowStockThreshold = 5;
      #productAvailable = true;

      connectedCallback() {
        this.#lowStockThreshold = Number(this.dataset.lowStockThreshold || 5);
        this.#productAvailable = this.dataset.productAvailable !== 'false';

        try {
          this.#variants = JSON.parse(this.dataset.variants || '[]');
        } catch (error) {
          this.#variants = [];
        }

        this.#boundVariantChange = (event) => this.#onVariantChange(event);
        document.addEventListener('variant:change', this.#boundVariantChange);
        this.#syncFromSelectedVariant();
      }

      disconnectedCallback() {
        document.removeEventListener(
          'variant:change',
          this.#boundVariantChange,
        );
      }

      #staticBadges() {
        return [...this.children].filter(
          (child) =>
            !child.matches('[data-badge-sale], [data-badge-low-stock]'),
        );
      }

      #selectedVariant() {
        // Prefer product-form / product-card. The gallery overlay sits outside
        // the form, so fall back to the section. Do not use [data-product-id]:
        // that matches this host and misses the sibling form input.
        const scope =
          this.closest('product-form') ||
          this.closest('.product-card') ||
          this.closest('form') ||
          this.closest('.shopify-section');
        const variantInput = scope?.querySelector('[data-variant-input]');
        const selectedId = variantInput ? Number(variantInput.value) : null;

        if (selectedId) {
          const match = this.#variants.find(
            (item) => Number(item.id) === selectedId,
          );
          if (match) return match;
        }

        return this.#variants[0] || null;
      }

      #syncFromSelectedVariant() {
        const full = this.#selectedVariant();

        if (!full) return;

        const onSale =
          this.#productAvailable &&
          Number(full.compare_at_price) > Number(full.price);

        const inventoryQty = Number(full.inventory_quantity ?? 0);
        const lowStock =
          Boolean(full.available) &&
          Boolean(full.inventory_management) &&
          inventoryQty > 0 &&
          inventoryQty <= this.#lowStockThreshold;

        this.#applyBadgeVisibility(onSale, lowStock);
        this.#applySaleLabel(full.sale_percent);
      }

      #saleLabel(percent) {
        const value = Number(percent);

        if (Number.isFinite(value) && value > 0) {
          const template = this.dataset.saleLabel || '';

          if (template.includes('__PERCENT__')) {
            return template.replace('__PERCENT__', String(value));
          }
        }

        return this.dataset.saleFallback || '';
      }

      #applySaleLabel(percent) {
        const label = this.querySelector('[data-badge-sale] .product-badge');

        if (!label) return;

        label.textContent = this.#saleLabel(percent);
      }

      #applyBadgeVisibility(onSale, lowStock) {
        const limit = Number(this.dataset.badgeLimit || 2);
        const staticBadges = this.#staticBadges();

        for (const badge of staticBadges) {
          badge.hidden = false;
        }

        let used = staticBadges.filter((badge) => !badge.hidden).length;

        const saleNode = this.querySelector('[data-badge-sale]');
        const lowStockNode = this.querySelector('[data-badge-low-stock]');

        if (saleNode) {
          if (onSale) {
            if (used >= limit && staticBadges.length > 0) {
              staticBadges[staticBadges.length - 1].hidden = true;
              used -= 1;
            }

            saleNode.hidden = used >= limit;
            if (!saleNode.hidden) used += 1;
          } else {
            saleNode.hidden = true;
          }
        }

        if (lowStockNode) {
          if (lowStock) {
            if (used >= limit && staticBadges.length > 0) {
              const lastVisible = [...staticBadges]
                .reverse()
                .find((badge) => !badge.hidden);

              if (lastVisible) {
                lastVisible.hidden = true;
                used -= 1;
              }
            }

            lowStockNode.hidden = used >= limit;
          } else {
            lowStockNode.hidden = true;
          }
        }
      }

      #onVariantChange(event) {
        const variant = event.detail?.variant;
        const eventProductId = event.detail?.product?.id;

        if (!variant?.id) return;

        // Ignore variant changes from other products (carousel cards, etc.)
        if (
          this.dataset.productId &&
          eventProductId != null &&
          Number(eventProductId) !== Number(this.dataset.productId)
        ) {
          return;
        }

        const full = this.#variants.find(
          (item) => Number(item.id) === Number(variant.id),
        );

        // Do not fall back to a foreign variant payload
        if (!full) return;

        const onSale =
          this.#productAvailable &&
          Number(full.compare_at_price) > Number(full.price);

        const inventoryQty = Number(full.inventory_quantity ?? 0);
        const lowStock =
          Boolean(full.available) &&
          Boolean(full.inventory_management) &&
          inventoryQty > 0 &&
          inventoryQty <= this.#lowStockThreshold;

        this.#applyBadgeVisibility(onSale, lowStock);
        this.#applySaleLabel(full.sale_percent);
      }
    }

    if (!customElements.get(NAME)) {
      customElements.define(NAME, ProductDynamicBadges);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Klaviyo owns the modal, the list and the validation — the theme only opens
     the merchant's chosen form and tells Klaviyo which variant it is for. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-notify-trigger]');

    if (!trigger) return;

    const formId = trigger.dataset.klaviyoFormId;

    if (!formId) return;

    event.preventDefault();

    window.__rokaNotifyContext = {
      variantId: trigger.dataset.variantId || null,
    };

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-complementary"] && !Shopify.designMode) return;
  try {
    /*
   * Mobile pagination for the Perfect Hue carousel. The list is a plain
   * scroll-snap row, so the indicator is derived from scroll position rather
   * than a carousel library. Panels are filled lazily by
   * product-complementary.js, hence the MutationObserver rebuild.
   */
  (() => {
    const buildBullets = (pagination, count) => {
      if (pagination.childElementCount === count) return;

      pagination.replaceChildren();

      if (count < 2) return;

      for (let index = 0; index < count; index += 1) {
        const bullet = document.createElement('span');
        bullet.className = 'carousel-pagination__bullet';
        pagination.append(bullet);
      }
    };

    const syncActive = (list, pagination) => {
      const bullets = pagination.children;

      if (!bullets.length) return;

      const first = list.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 20 : 1;
      const index = Math.min(
        bullets.length - 1,
        Math.max(0, Math.round(list.scrollLeft / step)),
      );

      for (let i = 0; i < bullets.length; i += 1) {
        bullets[i].classList.toggle(
          'carousel-pagination__bullet--active',
          i === index,
        );
      }
    };

    const bind = (pagination) => {
      const panel = pagination.closest('[data-perfect-hue-panel]');
      const scope = panel || pagination.closest('product-complementary');
      const list = scope?.querySelector('[data-complementary-list]');

      if (!list || pagination.dataset.bound === 'true') return;

      pagination.dataset.bound = 'true';

      const refresh = () => {
        buildBullets(pagination, list.childElementCount);
        syncActive(list, pagination);
      };

      list.addEventListener('scroll', () => syncActive(list, pagination), {
        passive: true,
      });
      new MutationObserver(refresh).observe(list, { childList: true });
      refresh();
    };

    const bindAll = () => {
      for (const pagination of document.querySelectorAll(
        '[data-complementary-pagination]',
      )) {
        bind(pagination);
      }
    };

    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
    document.addEventListener('colourway:change', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
